import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withRouter } from 'react-router'
import { admin } from 'routes/route.map'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import UpdateButtonComponent from './component'

export const Update = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'teams-table' }),
    withContext('appStore', StoreContext),
    withContext(
      'adminTeamsService',
      ServicesContext,
      ({ adminTeamsService }) => adminTeamsService
    ),
    withCallbacks(
      {
        onRouteToUpdateEditForm:
          (_state, { value, history }) =>
          () => {
            history.push(admin.teams.update.view(value.id))
          },
      },
      ['value']
    ),
  ],
})(UpdateButtonComponent)
